import { useEffect, useState } from 'react';
import { analyticsAPI } from '../lib/api';

export default function GoogleAnalytics() {
  const [trackingId, setTrackingId] = useState('');

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await analyticsAPI.getConfig();
        if (res.data.enabled && res.data.tracking_id) {
          setTrackingId(res.data.tracking_id);
        }
      } catch (err) {
        // Silently fail - analytics is optional
      }
    };
    loadConfig();
  }, []);

  useEffect(() => {
    if (!trackingId) return;

    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}');
    `;
    document.head.appendChild(script2);

    console.log(`Google Analytics initialized with ID: ${trackingId}`);

    return () => {
      // Cleanup if component unmounts
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, [trackingId]);

  // This component doesn't render anything
  return null;
}
